import { Form } from "react-bootstrap";
import styles from "./styles.module.sass";
import cn from "classnames";

const CheckboxForm = ({
  handleChange,
  label,
  formName,
  values,
  checkboxClass,
}) => {
  return (
    <Form.Group className={cn(styles.checkboxAdmin, checkboxClass)}>
      <Form.Check
        className={styles.checkboxContainer}
        label={label}
        name={formName}
        value={values[formName] ?? ""}
        onChange={handleChange}
        checked={!!values[formName]}
      />
    </Form.Group>
  );
};

export default CheckboxForm;
